import { FC } from 'react';
import { Checkbox, ConfigProvider } from 'antd';
import { Icon, IconName } from 'Components/UI';
import { IMDTheme } from 'Data/interfaces/MultiDomain/IMDTheme';
import { Container } from './styles';

export interface IDisciplinaItem {
  checked?: boolean;
  icon: IconName;
  disciplina: string;
  acronym?: string;
  disabled?: boolean;
  theme: IMDTheme;
  onCheck: () => void;
}

const DisciplinaItem: FC<IDisciplinaItem> = ({
  disciplina,
  icon,
  acronym,
  checked,
  disabled,
  theme,
  onCheck,
}) => {
  return (
    <ConfigProvider theme={{
      token: {
        colorBgContainerDisabled: `color-mix(in srgb, ${theme.colors.primary.primaryOutline}, ${theme.colors.surface.surface})`,
        colorTextDisabled: theme.colors.primary.onPrimary,
        colorPrimary: theme.colors.primary.primary
      }
    }}>
      <Container
        checked={checked}
        disabled={disabled}
        onClick={!disabled ? onCheck : undefined}
      >
        <Checkbox checked={checked} disabled={disabled} />
        <span className="iconContainer">
          <Icon icon={icon} customSize={22} color='cinzaPadrao' />
        </span>
        <span className="disciplinaTitle">{disciplina}</span>
        {!!acronym && <span className="disciplinaAcronym">{acronym}</span>}
      </Container>
    </ConfigProvider>
  );
};

export default DisciplinaItem;
